import React from "react";
import { Button, Flex, ModalV2 } from "@jsq/ds/core";

interface MultipleClientExportWarningModalProps {
  show: boolean;
  onContinue: () => void;
  handleDisplayMultipleClientDataExportModal: (show: boolean) => void;
}

const MultipleClientExportWarningModal: React.FC<MultipleClientExportWarningModalProps> = (
  props: MultipleClientExportWarningModalProps,
) => {
  const { show = false, onContinue, handleDisplayMultipleClientDataExportModal } = props;
  const onCancelOrHideHandler = () => {
    handleDisplayMultipleClientDataExportModal(false);
  };
  const onContinueHandler = () => {
    handleDisplayMultipleClientDataExportModal(false);
    onContinue();
  };

  return (
    <ModalV2 show={show} onHide={onCancelOrHideHandler} title="Selection warning">
      <ModalV2.Body>
        <Flex style={{ flexDirection: "column", gap: 20 }}>
          <div>
            The selection you have made contains Juniper Square data from more than one client.
            Before continuing, make sure that your selection is correct. Please be careful to
            minimize the risk of exposing client data.
          </div>
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex style={{ flexDirection: "row", justifyContent: "flex-end" }}>
          <Button
            onClick={onCancelOrHideHandler}
            variant="neutral"
            data-cy="multiple-client-export-warning-modal-cancel"
            data-testid="multiple-client-export-warning-modal-cancel"
          >
            Cancel
          </Button>
          <Button
            onClick={onContinueHandler}
            data-cy="multiple-client-export-warning-modal-continue"
            data-testid="multiple-client-export-warning-modal-continue"
          >
            Continue
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};

export default MultipleClientExportWarningModal;
